var map = {
	"./de.json": 71984,
	"./en.json": 83340,
	"./es.json": 79835,
	"./fr.json": 64535,
	"./it.json": 12626,
	"./nl.json": 10757,
	"./pt.json": 39735,
	"./vi.json": 58110
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(id => {
		return __webpack_require__.t(id, 3 | 16);;
	});
}
function webpackAsyncContextResolve(req) {
	return __webpack_require__.e(/* lazy-once context | index_19tfkia-i18n */ 578).then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 95553;
module.exports = webpackAsyncContext;